import { Layout } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmailInput, ReasonSelection, MonthSelection, PhonenumberInput, TextInput } from '../../simple-form-components';
import { ValidatedSelect } from '@cp-shared-19/frontend-ui';
import { DocumentsUpload, TransferTo } from './TenantDocumentUpload';
import { useField } from 'formik';

export const TenantChangeRequestForm: React.FC = () => {
    const { t } = useTranslation('request');
    const translationPrefix = 'category-selection.tenant';

    const translate = (key: string): string => {
        return t(`${translationPrefix}.${key}`);
    };

    const [field] = useField('tenantChangeRequest.transferTo');
    const selectedTransferTo: TransferTo = field.value;
    const transferTo: TransferTo[] = ['Personne physique', 'Personne morale'];

    return (
        <>
            <Layout.Item>
                <p
                    dangerouslySetInnerHTML={{
                        __html: translate('description'),
                    }}
                />
            </Layout.Item>
            <Layout.Item>
                <EmailInput
                    label={translate('email')}
                    name={'tenantChangeRequest.email'}
                    inputId="email-tenant-change-request"
                />
            </Layout.Item>
            <Layout.Item>
                <PhonenumberInput
                    label={translate('phonenumber')}
                    name={'tenantChangeRequest.phonenumber'}
                    isMandatory={false}
                    inputId="phone-number-tenant-change-request"
                />
            </Layout.Item>
            <Layout.Item>
                <MonthSelection
                    label={translate('transfer-date')}
                    name={'tenantChangeRequest.transferDate'}
                    isMandatory={true}
                    aria-required={true}
                />
            </Layout.Item>
            <Layout.Item>
                <ReasonSelection name={'tenantChangeRequest.reason'} />
            </Layout.Item>
            <Layout.Item>
                <ValidatedSelect
                    className="c-form-field--no-floating"
                    isMandatory={true}
                    requiredText=" *"
                    aria-required={true}
                    label={translate('transfer-to')}
                    name={'tenantChangeRequest.transferTo'}
                    selectItems={transferTo.map((transfer) => ({
                        value: transfer,
                        label: transfer,
                    }))}
                    emptyByDefault
                />
            </Layout.Item>
            <DocumentsUpload transferringTo={selectedTransferTo} />
            <Layout.Item>
                <TextInput label={translate('comment')} name={'tenantChangeRequest.comment'} isMandatory={false} />
            </Layout.Item>
        </>
    );
};
